import React, { useState, useEffect } from 'react';
import CardContainer from '../../components/card/card-container.jsx';
import Api from '../../api/global.service';
import { useHistory, useLocation } from 'react-router-dom';
import SicLinkCuentasTable from '../../components/tables/sic-link-cuentas-table.jsx';
import toggleIds from '../../utils/toggleIds.js';
import SicLinkTableParcela from '../../components/tables/sic-link-table-parcela.jsx';
import useEtiquetas from '../../hooks/useEtiquetas';
import transformWord from '../../utils/transformWord';

const VincularSicParcelasP2 = () => {
  const location = useLocation();
  const history = useHistory();
  const [dataParcelas, setDataParcelas] = useState([]);
  const [blocking, setBlocking] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const { etiquetas } = useEtiquetas();

  useEffect(() => {
    setBlocking(true);

    Api.get('admin/sic/parcelas_vinculables', location.state.cuentas[0].id_cuenta)
      .then(response => {
        setDataParcelas(response.data);
        setBlocking(false);
      })
      .catch(e => {
        setBlocking(false);
        // eslint-disable-next-line no-console
        console.log('e', e);
      });
  }, []);

  const navigateToNextStep = () => {
    if (selectedIds.length === 1) {
      const selected = dataParcelas.filter(it => selectedIds.includes(it.id));
      history.push({
        pathname: '/admin/vincular-sic-parcelas/list-p3',
        state: { cuentas: location.state.cuentas, parcelas: selected },
      });
    }
  };

  const navigateToNoParcela = () => {
    if (selectedIds.length === 0) {
      history.push({
        pathname: '/admin/vincular-sic-parcelas/list-No-parcela',
        state: { cuentas: location.state.cuentas },
      });
    }
  };

  const navigateToPreviousStep = () => history.goBack();

  return (
    <div>
      {/*
         // TODO: crear lógica de permiso
        {auth.hasPermission('VINCULAR_SIC') && (
      */}
      <>
        <CardContainer height={'100%'}>
          <div className="row"></div>
          <div className="row">
            <h3 className="col-xl-12 font-lato-normal-400">Cuenta Seleccionada</h3>
          </div>
          <div>
            <div className="row">
              <div className="col-xl-12">
                <SicLinkCuentasTable title="Cuentas Nuevas" data={location.state.cuentas} />
              </div>
            </div>
          </div>
          <div className="row"></div>
          <div className="row">
            <h2 className="col-xl-12 font-lato-normal-400">
              PASO 2: Elige UNA {transformWord(etiquetas?.parcela, ['singular','lowercase'])} de {location.state.cuentas[0].nombre} para vincular
            </h2>
          </div>
          <div>
            <div className="row">
              <div className="col-xl-12">
                <SicLinkTableParcela
                  title={transformWord(etiquetas?.parcela, ['plural','capitalize'])}
                  blocking={blocking}
                  data={dataParcelas}
                  toggleIds={toggleIds}
                  setter={setSelectedIds}
                  linkable
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-4">
                <button
                  onClick={navigateToPreviousStep}
                  type="button"
                  className="btn btn-outline-secondary"
                  style={{
                    borderRadius: '20px 20px 20px 20px',
                  }}>
                  <i className="fa fa-arrow-left"></i> Regresar a paso anterior
                </button>
              </div>
              <div className="col-4">
                <button
                  onClick={navigateToNextStep}
                  type="button"
                  className="btn btn-outline-secondary"
                  style={{
                    borderRadius: '20px 20px 20px 20px',
                  }}
                  disabled={selectedIds.length !== 1}>
                  Siguiente paso <i className="fa fa-arrow-right"></i>
                </button>
              </div>
              <div className="col-4">
                <button
                  onClick={navigateToNoParcela}
                  type="button"
                  className="btn btn-outline-secondary"
                  style={{
                    borderRadius: '20px 20px 20px 20px',
                  }}
                  disabled={selectedIds.length > 0}>
                  Continuar sin elegir {transformWord(etiquetas?.parcela, ['singular','lowercase'])} (crear a partir de ficha en siguiente paso){' '}
                  <i className="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </CardContainer>
      </>
    </div>
  );
};

export default VincularSicParcelasP2;
